module.exports = __webpack_public_path__ + "img/Frame 1321315177@2x.cbce7850.png";